import { Box, Typography, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { colorPrimary } from "../../../theme";

interface SearchCardProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
}

export function SearchCard({
  placeholder = "O que você busca?",
  value,
  onChange,
}: SearchCardProps) {
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        p: 2,
        borderRadius: 3,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* Título */}
      <Box mb={2}>
        <Typography
          fontWeight={700}
          fontSize="0.7rem"
          letterSpacing={1.5}
          textTransform="uppercase"
          color="text.secondary"
        >
          Procurar
        </Typography>

        <Box
          sx={{
            width: 32,
            height: 4,
            bgcolor: colorPrimary,
            mt: 0.5,
            borderRadius: 2,
          }}
        />
      </Box>

      {/* Campo de busca */}
      <TextField
        fullWidth
        size="small"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon fontSize="small" color="disabled" />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            backgroundColor: "action.hover",
            
          },
        }}
      />
    </Box>
  );
}
